export const SearchLoadingScreen = () => {
  return <div className="grid grid-cols-2 gap-[8px] tablet-sm:grid-cols-3 tablet-lg:grid-cols-4 laptop-lg:grid-cols-5" data-sentry-component="SearchLoadingScreen" data-sentry-source-file="SearchLoadingScreen.tsx">
      {Array.from({
      length: 30
    }).map((_, index) => {
      return <div key={index} className={`mb-[26px] h-[200px] animate-pulse rounded-2xs bg-gray-50`} />;
    })}
    </div>;
};